import React from 'react';
import createReactClass from 'create-react-class';
// import { Panel } from 'react-bootstrap';

import SharedStringGeneratorMixin from '../../../../../embed/lib/SharedStringGeneratorMixin';
import ClipboardButton from '../../../../../lib/components/form/ClipboardButton';

const noop = function () {};

var InternalHosting = createReactClass({
    mixins: [
        SharedStringGeneratorMixin
    ],

    render: function () {
        var { clientID, event } = this.props;

        var hostedString = this.getHost() +
            '?clientID=' + clientID +
            '&eventID=' + event.eventID;

        if (this.props.forceBasic) hostedString += '&simple=true';

        return (
          <div style={{position: 'relative'}}>
            <input
              type='text'
              className='form-control'
              readOnly
              value={hostedString}
              onChange={noop}
            />
            <ClipboardButton value={hostedString} style={{position: 'absolute', top: 0, right: 0}}/>
          </div>
        )
    }
});

export default InternalHosting;
